module.exports = __webpack_public_path__ + "fonts/Inter-400-latin31.5eb4a77.woff2";